export const getDevicePlatform = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (
            getDevicePlatform.Android() ||
            getDevicePlatform.BlackBerry() ||
            getDevicePlatform.iOS() ||
            getDevicePlatform.Opera() ||
            getDevicePlatform.Windows()
        );
    },
};

// This function checks if a rich text field is blank as kontent.ai returns "<p><br></p>" for blank fields.
export const isRichTextFieldBlank = (richtext: string): boolean => {
    return richtext === '<p><br></p>';
};
